import {
    pbev_101,
    pbev_201,
    pbev_202,
    pbev_203,
    pbev_204,
    pbev_301,
    pbev_302,
    pbev_303,
    pbev_304,
    pbev_305,
    pbev_307,
    phev_video_001,
    phev_video_002,
    phev_video_003,
    phev_video_004,
    phev_video_005,
    phev_video_006,
    phev_video_007,
    phev_video_008,
    phev_video_009,
    phev_video_010,
    phev_video_011,
    phev2_101,
    phev2_201,
    phev2_202,
    phev2_203,
    phev2_204,
    phev2_301,
    phev2_302,
    phev2_303,
    phev2_304,
    phev2_305,
    phev2_307,
    phev3_101,
    phev3_201,
    phev3_202,
    phev3_203,
    phev3_204,
    phev3_301,
    phev3_302,
    phev3_303,
    phev3_304,
    phev3_305,

    phev3_307,
    phev4_101,
    phev4_201,
    phev4_202,
    phev4_203,
    phev4_204,
    phev4_301,
    phev4_302,
    phev4_303,
    phev4_304,
    phev4_305,

    phev4_307,
    phev5_101,
    phev5_201,
    phev5_202,
    phev5_203,
    phev5_204,
    phev5_301,
    phev5_302,
    phev5_303,
    phev5_304,
    phev5_305,

    phev5_307,
    phev6_101,
    phev6_201,
    phev6_202,
    phev6_203,
    phev6_204,
    phev6_301,
    phev6_302,
    phev6_303,
    phev6_304,
    phev6_305,

    phev6_307,
    phev7_101,
    phev7_201,
    phev7_202,
    phev7_203,
    phev7_204,
    phev7_301,
    phev7_302,
    phev7_303,
    phev7_304,
    phev7_305,

    phev7_307,
    phev8_101,
    phev8_201,
    phev8_202,
    phev8_203,
    phev8_204,
    phev8_301,
    phev8_302,
    phev8_303,
    phev8_304,
    phev8_305,

    phev8_307,
    phev9_101,
    phev9_201,
    phev9_202,
    phev9_203,
    phev9_204,
    phev9_301,
    phev9_302,
    phev9_303,
    phev9_304,
    phev9_305,

    phev9_307,
    phev10_101,
    phev10_201,
    phev10_202,
    phev10_203,
    phev10_204,
    phev10_301,
    phev10_302,
    phev10_303,
    phev10_304,
    phev10_305,
    phev10_307,

    phev11_101, phev11_201, phev11_301, phev11_307,

} from "../../components/config";

let data1 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/22175505GA45.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/24152534W5F5.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/221757479t87.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/2319035540M0.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/23190416h2hj.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202009/0110211217w6.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/22175941WN9H.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/221800016Zgt.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/221800570A7g.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/24120017gNA3.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/2412003440t2.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/221801220J47.jpg",
    },
    sec1: {
        url: phev2_101,
    },
    sec2: {
        bacUrl: phev2_201,
        text:
            "风里回荡着驼铃声，砖石镌刻着岁月的印记，西域文化的独特韵味，在大漠孤烟直的意境中凝聚，跟随上汽大众PHEV千里之行的车队，走进传奇西域。",
        img2: "https://www.csvw.com/u/cms/www/202008/18131751KP20.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/181318232467.jpg",
        img4: "https://www.csvw.com/u/cms/www/202009/0110184898eY.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/1813200634Q3.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/181320247v1B.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202009/01102002KNm4.jpg",
    },
    sec3: {
        bacUrl: phev2_301,
        list: [
            {
                title: "吐鲁番吐峪沟",
                text:
                    "一望无垠，黄沙千里，披着神秘面纱的西域令人神往，车队沿着吐峪沟大峡谷前行，来到了新疆现存最古老的维吾尔族村落，吐峪沟麻扎村。不惧风沙，不畏岁月，麻扎村已在此静静矗立了1700多年，至今保存着维吾尔族古老民俗风情，村中大量生土建造的传统民居，为其赢得了“中国第一土庄”的美誉。",
                img1: "https://www.csvw.com/u/cms/www/202008/181323144Rnx.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/011019349n85.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/18132733gWf8.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/01102049s03o.jpg",
            },
            {
                title: "鄯善库木塔格沙漠",
                text:
                    "“目无飞鸟，下无走兽，复无水草”，中国八大沙漠之一库木塔格沙漠，正如古籍记载中的一样，天地苍茫，无边无垠。正是因为如此，这里成为了极限运动爱好者的宝地，当车轮卷起黄沙，或许你会赞叹人类的毅力。",
                img1: "https://www.csvw.com/u/cms/www/202008/181324397232.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/18132456642G.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/1813280544b2.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/181328231Uq9.jpg",
            },
            {
                title: "敦煌",
                text:
                    "《汉书》中说“敦，大也；煌，盛也”，作为河西走廊最西端的城市，敦煌见证着西域与中原，千百年来的文化交流与经济往来。被沙漠戈壁包围的敦煌，东有三危山，南有鸣沙山，一湾月牙泉静候着无数旅人，耸立的莫高窟凝视着历史变迁，作为城标的飞天雕像栩栩如生，成为了敦煌的精神图腾。",
                img1: "https://www.csvw.com/u/cms/www/202008/1813251478t6.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/18132532eWOh.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/181328425403.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/18132858DC11.jpg",
            },
            {
                title: "嘉峪关关城",
                text:
                    "“一夫当关，万夫莫开”，沿着历史的足迹，车队行驶到了，被誉为“天下第一雄关”的嘉峪关。这里地势险要，攻防兼备，在古时扼守着边陲咽喉要道，同时也是古丝绸之路的重要驿站，雄关漫道，黄沙烈烈，烽火远去，嘉峪关的雄险气势分毫不减。",
                img1: "https://www.csvw.com/u/cms/www/202008/18132549r4F3.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/18132607909p.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/181329150Z2z.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/181329317nbB.jpg",
            },
            {
                title: "酒泉",
                text:
                    "钟鼓楼静静地矗立在甘肃酒泉市十字街中心注视着繁华热闹的街区，见证着古往今来。寻迹前行，西汉酒泉胜迹岂容错过，这座汉市园林兼有西北的雄浑之气，江南的婉约之美，其蕴藏的历史内涵更是源远流长。西汉名将霍去病、民族英雄左宗棠，他们开疆守土的壮歌都能在这里寻到痕迹。",
                img1: "https://www.csvw.com/u/cms/www/202009/01101914VZb6.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/1813264534U2.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/01102028V308.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/181330024IpQ.jpg",
            },
        ],
        videoImg: phev2_307,
        videoUrl: phev_video_001,
    },
};

let data2 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/261219177wv9.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/26121936E7rZ.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/26121954ocN3.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202009/01102807uVS5.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/261220273E6m.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/26122041H0U6.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/26122103307G.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/2612212763sQ.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/26122146SGh2.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/26122202b302.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/26122221wN36.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/2612223873AZ.jpg",
    },
    sec1: {
        url: "https://www.csvw.com/u/cms/www/202008/18130843c98c.jpg",
    },
    sec2: {
        bacUrl: "https://www.csvw.com/u/cms/www/202009/02170300Oc11.jpg",
        text:
            "沙漠戈壁，随着驼铃声渐行渐远，丹霞、雪山、琥珀、草原……新的风景逐渐映入眼帘，寻自然之遐想，怀古今之万事，跟随上汽大众PHEV千里之行车队继续前行！",
        img2: "https://www.csvw.com/u/cms/www/202009/0110243118NJ.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/181334033LZD.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/181334225926.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202009/011026462wT8.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/181339447084.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/18134000s1Da.jpg",
    },
    sec3: {
        bacUrl: "https://www.csvw.com/u/cms/www/202009/01102852M6Ca.jpg",
        list: [
            {
                title: "丹霞地质公园",
                text:
                    "张掖丹霞被誉为“中国最美的七大丹霞之一”，它的美就像是被上帝打翻了调色盘，美得绚烂多彩，动人心魄，驱车前行，像是赴一场自然制造的斑斓盛宴。",
                img1: "https://www.csvw.com/u/cms/www/202008/181334489P56.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/181335042T95.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/18134109aKLS.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/18134124FQ88.jpg",
            },
            {
                title: "马蹄寺",
                text:
                    "巍巍祁连山，苍苍马蹄寺，这座峭壁上的千年佛寺，不仅拥有厚重的历史，更拥有着秀丽的风光和质朴的人情，远处大山上常年不化的积雪、山间弥漫的雾气、潺潺的小溪。",
                img1: "https://www.csvw.com/u/cms/www/202009/01102555j84P.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/01102621ko8w.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/011027309A4N.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/0110274772KL.jpg",
            },
            {
                title: "甘州府城",
                text:
                    "离开马蹄寺，车队驰行到了坐落于张掖滨河新区的甘州府城，仿古城墙巍然屹立，亭台楼宇鳞次栉比，这座集历史和现代于一身的特色园区，别有一番古风古味。",
                img1: "https://www.csvw.com/u/cms/www/202008/181336567O5n.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/181337115Rab.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/18134225Z4UP.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/1813424120E3.jpg",
            },
            {
                title: "扁都口",
                text:
                    "千里之行，美好总会不期而遇，7月的扁都口阳光不燥、清风怡人，是夏日的避暑圣地，油菜花漫山遍野地怒放着，绵延不绝，与翠绿的草地、悠蓝的天空、葱郁的远山相映成趣。上汽大众PHEV车队缓行在花海之中，带你云游这无边美景，感受西域高原别样的柔与美。草原上成群的牛羊或低头悠闲觅食，或追逐嬉戏，碧云天，黄花地，此情此景令人心旷神怡，如痴如醉。",
                img1: "https://www.csvw.com/u/cms/www/202008/18133730ybqC.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/0110252758wg.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/1813430108c7.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/01102708fh62.jpg",
            },
            {
                title: "盘大公路",
                text:
                    "伴随着一路美景，车队恋恋不舍地告别了扁都口，沿着蜿蜒曲折的盘大公路继续前行，险、奇、秀是它送给车队的“名片”。山间弯道一环连着一环，路面湿滑泥泞，路况复杂，好在车队顺利通过了这一小小的考验。",
                img1: "https://www.csvw.com/u/cms/www/202008/181338011922.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/181338184K5T.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/18134335426i.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/18134351B13z.jpg",
            },
            {
                title: "青海湖-尕海",
                text:
                    "征服过崎岖的山路，才更懂欣赏下一程的美景，车队经过盘大公路抵达了青海湖尕海，这里的美只有亲自去过才能体会。尕海宛若镶嵌在碧绿草毯上的一颗明珠，朗阔浩渺，波光潋滟，散发出属于自己独一无二的魅力，途经至此，车队差点又被这静美的景色拦下脚步。",
                img1: "https://www.csvw.com/u/cms/www/202008/181338333IL6.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/1813384917Q4.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/18134408B5Ai.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/18134424XM19.jpg",
            },
        ],
        videoImg: phev3_307,
        videoUrl: phev_video_002,
    },
};

let data3 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/26102848A7U0.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/261029105tm1.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/261029391v9E.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/26102955R1GT.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202009/01103517936w.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202009/0110353842M3.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/26103051k864.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/26103112Z370.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/26103132U82O.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/26103206e7oz.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/26103226404m.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/261032412A13.jpg",
    },
    sec1: {
        url: phev4_101,
    },
    sec2: {
        bacUrl: phev4_201,
        text:
            "又是一个醉人的清晨，车队从西宁启程，连绵的青山，潺潺的长河，还有那绒毯一般的草场，交替而出，相伴同行，上汽大众PHEV千里之行，驰骋于高原明珠之上，流连于黄河之畔，带你一起，领略这旖旎美景。",
        img2: phev4_202,
        img3: "https://www.csvw.com/u/cms/www/202009/01103014m7bp.jpg",
        img4: "https://www.csvw.com/u/cms/www/202009/01103109062F.jpg",
        img2Pop: require("../../assets/phev/imgs/big/huanghe/1.jpg"),
        img3Pop: "https://www.csvw.com/u/cms/www/202009/0110334674y0.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202009/01103404x4g7.jpg",
    },
    sec3: {
        bacUrl: "https://www.csvw.com/u/cms/www/202009/01173757K479.jpg",
        list: [
            {
                title: "魅力刘家峡",
                text:
                    "位于永靖县的公航旅·黄河三峡自驾游基地，是一处与黄河毗邻的露营胜地，这里绿草如茵，清水环绕，木屋成林，房车、露营、垂钓、卡丁车等尽皆齐备，是无数自驾爱好者停留休整的必选之地，不来打卡一番，岂不可惜!对自由，我们永不停歇地追逐，对天空，我们从不放弃飞翔的渴望，刘家峡国际滑翔营同样处于永靖县境内，许是沾了刘家峡水库的地利，这里上升气流稳定，气温适中，是开展滑翔伞等航空体育运动的理想之地。飞天勇士们从长夷岭起飞，在刘家峡向阳码头回归，遨游于朗朗晴空，迎着和煦暖风高飞俯视，一览天下。东起刘家峡大坝，西至炳灵寺峡口，刘家峡水库是我国第一座百万千瓦级大型水电站，为甘肃、陕西、青海等省输送电能。一声“开闸”，这里水龙咆哮，气势如虹，翻江倒海，威震群山！都知道黄河九曲十八弯，蜿蜒向东，有多少人得以近观？溯流而行，让我们跟随车队一起，近距离围观这古老黄河的不凡风貌，蓝天白云为幕，群山碧草点缀，清风鸟鸣做歌，偶得一汪黄河水，洗净了满身尘埃。随山飞驰，心随着河水的色泽变换而奔腾，这是专属于西北的豪迈之歌，也是我们源远流长的时间长河。",
                img1: "https://www.csvw.com/u/cms/www/202009/011033089702.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/01103325pE76.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/0110343884UI.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/0110345585We.jpg",
            },
            {
                title: "金城兰州",
                text:
                    "兰州，黄河穿城而过，一座座大桥点缀着黄河，深安黄河大桥也是如此，展翅蝶形的造型，犹如停驻在黄河上，即将高飞的蝴蝶，吐露了兰州搏击风浪、赶赴时代浪潮的心，飞驰在桥上，真是让人快慰！沿着黄河向前，上汽大众PHEV车队转眼就到了银滩湿地公园，伏羲女娲主题雕塑瞬间吸引了所有的视线，在华夏人文始祖园，在这哺育我们数千年的母亲河边，用心品读华夏文明的传承与延续。来到兰州，正宗的牛肉面不可不尝，踩一脚油门，闻香而至，“一清、二白、三绿、四红、五黄”，兰州牛肉面用了200多年的时间，一统拉面江湖，享誉全国各地。黄河落日，华灯初上，有着“黄河第一桥”美名的中山桥，静静地横卧在河面上，远远望去，仿若一骑飞虹横跨天堑，连接着南北两岸。",
                img1: "https://www.csvw.com/u/cms/www/202009/011032547K3v.jpg",
                img2: require("../../assets/phev/imgs/small/huanghe/jincheng2.jpg"),
                img1Pop: "https://www.csvw.com/u/cms/www/202009/01103420bdm2.jpg",
                img2Pop: require("../../assets/phev/imgs/big/huanghe/jincheng2.jpg"),
            },
        ],
        videoImg: phev4_307,
        videoUrl: phev_video_003,
    },
};

let data4 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/26103352rrm1.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/261034085Xx7.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/261034263TB3.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/26103451Az94.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202009/02170521efaM.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/26103523q614.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/26103542fJnr.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/26103607X515.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/261036336f03.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/261036505h1m.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/26103705b05x.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/26103721028R.jpg",
    },
    sec1: {
        url: phev5_101,
    },
    sec2: {
        bacUrl: phev5_201,
        text:
            "黄河汹涌的浪涛声犹在耳边，波澜壮阔的新“画卷”，一起随着上汽大众PHEV千里之行车队的前进，缓缓铺开，这一站，我们将去往红色文化基地——延安。",
        img2: phev5_202,
        img3: "https://www.csvw.com/u/cms/www/202009/02170143G76M.jpg",
        img4: phev5_204,
        img2Pop: require("../../assets/phev/imgs/big/hongse/1.jpg"),
        img3Pop: "https://www.csvw.com/u/cms/www/202009/02165948vb21.jpg",
        img4Pop: require("../../assets/phev/imgs/big/hongse/3.jpg"),
    },
    sec3: {
        bacUrl: phev5_301,
        list: [
            {
                title: "黄帝陵",
                text:
                    "就着小雨，车队来到了，位于桥山之巅的黄帝陵景区，黄帝陵是历朝历代祭祀华夏始祖黄帝的场所，有着天下第一陵之称。陵园掩映在湖光山色之间，更显庄严肃穆，当年，毛泽东亲撰《祭黄帝陵文》，号召建立抗日民族统一战线，每当想起，令人心潮澎湃。",
                img1: require("../../assets/phev/imgs/small/hongse/huangdi1.jpg"),
                img2: "https://www.csvw.com/u/cms/www/202009/0110395168j1.jpg",
                img1Pop: require("../../assets/phev/imgs/big/hongse/huangdi1.jpg"),
                img2Pop: "https://www.csvw.com/u/cms/www/202009/011041050633.jpg",
            },
            {
                title: "延安革命纪念馆",
                text:
                    "驱车百余公里，车队来到了延安革命纪念馆。展馆迄今已有70年历史，是新中国成立后建成的最早的革命纪念馆之一，广场正中屹立着毛泽东的青铜像，馆内还展出了众多珍贵的历史资料，如果你想瞻仰中国革命圣地，这里可以让你不虚此行。",
                img1: require("../../assets/phev/imgs/small/hongse/yanan1.jpg"),
                img2: "https://www.csvw.com/u/cms/www/202009/011039290963.jpg",
                img1Pop: require("../../assets/phev/imgs/big/hongse/yanan1.jpg"),
                img2Pop: "https://www.csvw.com/u/cms/www/202009/01104140338p.jpg",
            },
            {
                title: "宝塔山",
                text:
                    "“几回回梦里回延安，双手搂定宝塔山”，毗邻延安革命纪念馆的，正是赫赫有名的宝塔山。车队沿着山路盘旋而上，只见林木茂盛、景色深幽，摩崖石刻群和碑林令人驻足，矗立山巅的宝塔始建于唐代，塔旁铸于明代的铁钟，曾在革命时期被用于报时和报警，立下不朽功勋。",
                img1: "https://www.csvw.com/u/cms/www/202009/01173537B11s.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/011038373uOg.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/011735079k70.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/0217291785L5.jpg",
            },
            {
                title: "杨家岭",
                text:
                    "作为曾经的中共中央驻地，杨家岭见证了众多历史事件的发生，留下了众多革命前辈的足迹。决策在这里酝酿，曙光在这里亮起，一排排窑洞，正是中国革命的摇篮。",
                img1: require("../../assets/phev/imgs/small/hongse/yang1.jpg"),
                img2: "https://www.csvw.com/u/cms/www/202009/01104030717C.jpg",
                img1Pop: require("../../assets/phev/imgs/big/hongse/yang1.jpg"),
                img2Pop: "https://www.csvw.com/u/cms/www/202009/01104203d1zg.jpg",
            },
            {
                title: "梁家河",
                text:
                    "黄土高原沟壑纵横、大地广袤，在知识青年上山下乡的热潮中，陕北黄土高原上的梁家河，成了众多知青插队落户之处，这里淳厚朴实的民风影响了他们的一生。知青井、知青旧居和村史馆等，向后人诉说着这段历史。",
                img1: "https://www.csvw.com/u/cms/www/202009/011040086ws4.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/20001424D4M3.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/011041230414.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/2000135645op.jpg",
            },
            {
                title: "美食",
                text:
                    "天色已逐渐暗了下来，地道的肉夹馍、凉粉色泽诱人，油糕、洋芋擦擦、荞面饸铬、钱钱饭等特色美食，让人“欲罢不能”。如果有机会，一定要来亲自体验一番。",
                img1: require("../../assets/phev/imgs/small/hongse/mei1.jpg"),
                img2: require("../../assets/phev/imgs/small/hongse/mei2.jpg"),
                img1Pop: require("../../assets/phev/imgs/big/hongse/mei1.jpg"),
                img2Pop: require("../../assets/phev/imgs/big/hongse/mei2.jpg"),
            },
        ],
        videoImg: phev5_307,
        videoUrl: phev_video_004,
    },
};

let data5 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/26103837F0BE.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/26103852b65J.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/26103914rluc.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/26103931VEZN.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/261039473523.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/2610400282WB.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/26104021e870.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/26104045k38J.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/26104105y798.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/26104122a6hf.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/26104136iAxe.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/26104155v334.jpg",
    },
    sec1: {
        url: phev6_101,
    },
    sec2: {
        bacUrl: phev6_201,
        text:
            "华夏荣耀传古今，浩瀚山水揽胜境，上汽大众PHEV千里之行车队从红色基地延安一路驰骋来到千年古都西安，感受着历史与现代的交错，这场古今对话之旅将碰撞出怎样的火花。",
        img2: "https://www.csvw.com/u/cms/www/202009/0110460512W2.jpg",
        img3: phev6_203,
        img4: phev6_204,
        img2Pop: "https://www.csvw.com/u/cms/www/202009/01104956Rt33.jpg",
        img3Pop: require("../../assets/phev/imgs/big/qiannian/2.jpg"),
        img4Pop: require("../../assets/phev/imgs/big/qiannian/3.jpg"),
    },
    sec3: {
        bacUrl: "https://www.csvw.com/u/cms/www/202009/04184152bbGG.jpg",
        list: [
            {
                title: "广仁寺",
                text:
                    "隐匿在西安明城墙内西北角的广仁寺，乃康熙敕建，距今有三百多年历史，是中国唯一绿度母主道场，安定西北，广布仁慈，这座寺院是多民族文化交流的历史见证，轻车缓行，红墙灰砖，梵音绕梁，静谧中带着一丝神秘。",
                img1: "https://www.csvw.com/u/cms/www/202009/01104641YLb0.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/0110465893vO.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/01105054lTcO.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/0110511600yL.jpg",
            },
            {
                title: "西安城墙",
                text:
                    "巍峨的城墙，就像一本厚重的无字史书，一砖一瓦都封存着跌宕起伏的历史烽火，上汽大众PHEV千里之行车队，于不同的城门之间穿梭行进，恍若经过了一个个“时光隧道”，穿越在现代和历史之间。",
                img1: "https://www.csvw.com/u/cms/www/202009/04184313u2TJ.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/04184350Wc58.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/04184253l7Oo.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/04184336c1y7.jpg",
            },
            {
                title: "大雁塔",
                text:
                    "移步换景，车队来到屹立在距离城墙不远处的大雁塔附近，作为现存最早、规模最大的唐代四方楼阁式砖塔，大雁塔是我国佛教建筑艺术中不可多得的杰作，停车驻足，听檐角风铃声响，看塔宇恢宏气势，感受着古都沧桑千年的故事。",
                img1: "https://www.csvw.com/u/cms/www/202009/011046220855.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/200012562050.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/01105023551V.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/200013326a35.jpg",
            },
            {
                title: "大唐不夜城",
                text:
                    "大雁塔脚下的大唐不夜城，成为车队一行赞叹不已的绝佳网红打卡点，游园区、赏花灯、看表演，灯光璀璨、锣鼓喧天，实在令人眼花缭乱。",
                img1: require("../../assets/phev/imgs/small/qiannian/datang1.jpg"),
                img2: "https://www.csvw.com/u/cms/www/202008/20001221OXYG.jpg",
                img1Pop: require("../../assets/phev/imgs/big/qiannian/datang1.jpg"),
                img2Pop: "https://www.csvw.com/u/cms/www/202008/200012026D67.jpg"
            },
            {
                title: "曲江寒窑遗址公园",
                text:
                    "在古色古香的马路上继续驰行，夜色中，灯火霓虹的曲江寒窑遗址公园闯入了车队的视线，这座以爱情为主题的文化公园，与大雁塔、大唐不夜城隔水相望，入口的牌楼雄伟壮观，雕梁画栋，古色古韵，车队停驻在此带你静静感受，薛平贵和王宝钏的千年爱情故事。",
                img1: "https://www.csvw.com/u/cms/www/202009/01104821189w.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/01104839045A.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/011053114zIi.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/011053343bg6.jpg",
            },
            {
                title: "骊山",
                text:
                    "“骊山云树郁苍苍，历尽周秦与汉唐”，千百年来，有多少历史在这里更迭上演。西周末年，周幽王为博褒姒一笑，不惜烽火戏诸侯。秦始皇在骊山北麓，为自己修建了气势恢宏的地下宫殿，建造了被誉为“世界第八大奇迹”的兵马俑。骊山脚下，华清池畔，透过历史的遗存，仿若能窥见，唐玄宗与杨贵妃浪漫又悲凉的爱情绝唱。除去厚重的历史文化，临潼绮丽的自然景观，同样拥有着令人无法抗拒的魅力，沿着骊山最美环山路，车队盘旋而上，两旁林木郁郁葱葱，美景尽收眼底。",
                img1: "https://www.csvw.com/u/cms/www/202009/011047490Z47.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/01104805u2Bc.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/01105238658w.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/01105255Fx66.jpg",
            },
            {
                title: "贾平凹文化艺术馆",
                text:
                    "当车队伫立在这座赋予建筑以文学诗性的艺术馆前，一场博大精深与魅力独具的文化之旅正式开启，清水砖墙的独特设计，简洁大气的环境，浓郁的书香气，真让人沉醉于此而不知归。",
                img1: "https://www.csvw.com/u/cms/www/202009/011047163aus.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/0110473467ZY.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/01105200gz9A.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/011052197782.jpg",
            },
            {
                title: "美食",
                text:
                    "说到美食，西安绝对是不可错过的城市，肉夹馍、凉皮、biangbiang面、油泼面、肉丸胡辣汤，如同西安这座城一样统统五星推荐，再加一句“撩咋咧”的好评，尽管已经有如此多的美食，羊肉泡馍却依然是西安美食中的“c位”，让人馋涎欲滴，余味绕梁，或许正是因为这些诱惑，车队可谓是马不停蹄。",
                img1: require("../../assets/phev/imgs/small/qiannian/meishi1.jpg"),
                img2: require("../../assets/phev/imgs/small/qiannian/meishi2.jpg"),
                img1Pop: require("../../assets/phev/imgs/big/qiannian/meishi1.jpg"),
                img2Pop: require("../../assets/phev/imgs/big/qiannian/meishi2.jpg"),
            },
        ],
        videoImg: phev6_307,
        videoUrl: phev_video_005,
    },
};

let data6 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/261307371c73.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/26130811Hq30.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/261308272uZ3.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/2613084840v5.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202009/0110580519jY.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202009/011058259n4W.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/26130948S94C.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/261310117l5L.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/26131032r03e.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/261310491829.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/26131107glo9.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/261311237359.jpg",
    },
    sec1: {
        url: pbev_101,
    },
    sec2: {
        bacUrl: pbev_201,
        text:
            "清晨，车队在烈烈唐风中，挥别西安，转向西南，翻越秦岭，向着承载了威威大汉气象的汉中而去，上汽大众PHEV千里之行，在群山绿海间游弋，在蜿蜒山脉中穿越，带你一起，追寻最纯粹的汉家文明。",
        img2: "https://www.csvw.com/u/cms/www/202008/28161509I108.jpg",
        img3: "https://www.csvw.com/u/cms/www/202009/011055117e49.jpg",
        img4: "https://www.csvw.com/u/cms/www/202009/01105551n7iJ.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/281615433EZk.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202009/01105649f4eO.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202009/011057080406.jpg",
    },
    sec3: {
        bacUrl: pbev_301,
        list: [
            {
                title: "汉中",
                text:
                    "汉中依山傍水，携古传今，山崖之间，镌刻着千年的文明，这里的褒斜道始于战国，这里的石门，是世界上最早的人工通车隧道，这里是国之瑰宝“石门十三品”摩崖石刻的所在地，这里的褒河鲜鱼名声在外，饕餮纷至。",
                img1: require("../../assets/phev/imgs/small/xinghan/hanzhong1.jpg"),
                img2: "https://www.csvw.com/u/cms/www/202009/0117364566aJ.jpg",
                img1Pop: require("../../assets/phev/imgs/big/xinghan/hanzhong1.jpg"),
                img2Pop: "https://www.csvw.com/u/cms/www/202009/011736005l75.jpg",
            },
            {
                title: "石门栈道景区",
                text:
                    "石门栈道景区，是西北的水利明珠，是褒姒的故里，是栈道之乡，是石门水库之所在，是珍稀动植物的乐园，更是我们念念不忘，心之向往的所在，斑驳的石块古迹荟萃，飒飒的山风呜咽长歌，文明就在这里！静待着后嗣的追寻回溯。",
                img1: require("../../assets/phev/imgs/small/xinghan/shimen1.jpg"),
                img2: require("../../assets/phev/imgs/small/xinghan/shimen2.jpg"),
                img1Pop: require("../../assets/phev/imgs/big/xinghan/xinghan1.jpg"),
                img2Pop: "https://www.csvw.com/u/cms/www/202009/03142112Zc64.jpg",
            },
            {
                title: "兴汉胜境景区",
                text:
                    "兴汉胜境景区，古色古香，颇有意趣，褪下满身的尘埃，洗去一路的疲惫，换上一身汉服，行走在夕阳之下，个性鲜明的汉代建筑之中，不远处水鸟晚归而啼，风中隐隐是低沉埙音。一场烟火，一曲汉歌， 一部水幕《天汉传奇》，让人恍惚间，仿佛穿越了时空，这就是汉中，承袭千年的汉文化浓缩于此，也彰显于此。",
                img1: require("../../assets/phev/imgs/small/xinghan/xinghan1.jpg"),
                img2: "https://www.csvw.com/u/cms/www/202009/011655306F9R.jpg",
                img1Pop: require("../../assets/phev/imgs/big/xinghan/shimen1.jpg"),
                img2Pop: "https://www.csvw.com/u/cms/www/202009/01105725Amt9.jpg",
            },
        ],
        videoImg: pbev_307,
        videoUrl: phev_video_006,
    },
};

let data7 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/261312481333.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/2613130634lG.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/261313232JLf.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/2613134169oX.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/26131357t8c2.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/26131411K034.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/261314282uip.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/26131443A59F.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/26131505W46G.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/26131522n528.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/261315356An2.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/26131552P338.jpg",
    },
    sec1: {
        url: phev7_101,
    },
    sec2: {
        bacUrl: phev7_201,
        text:
            "7月的成都如火如荼，成都车展的举行，点燃了这座巴蜀名城，在参观完2020年的首个A级车展后，不如打卡成都街头，品味悠然生活，时尚与古典交融，美食与美景相济，一场蜀中“巴适”之旅，正在缓缓展开，和上汽大众PHEV车队一起， 走起来!",
        img2: "https://www.csvw.com/u/cms/www/202008/16190752B5M5.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/16190808674R.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/161908254y4i.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/16184533SAE4.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/1618473320bH.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/16184806i3gH.jpg",
    },
    sec3: {
        bacUrl: phev7_301,
        list: [
            {
                title: "远洋太古里",
                text:
                    "从天府立交桥到泡桐树街，从环球中心到国际金融中心，驰行在成都街头，繁华都市的现代摩登风情一览无余。停车驻足，在远洋太古里逛一逛，无论是国际大牌，还是咖啡西餐，你想要的都能在这座时尚地标中找到。",
                img1: "https://www.csvw.com/u/cms/www/202009/01165025xdO3.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/17135207X6DR.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/011100293052.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/17135236n645.jpg",
            },
            {
                title: "武侯祠&杜甫草堂",
                text:
                    "来成都，武侯祠和杜甫草堂是必去的打卡圣地，蜀汉丞相诸葛亮，“三顾频烦天下计，两朝开济老臣心”的赤胆忠心。大唐诗人杜甫，“安得广厦千万间，大庇天下寒士俱欢颜”的家国情怀，经过千百年时光的洗涤，依然不曾褪色，与武侯祠为邻、古韵独具的锦里古街，自然也不容错过，品尝特色小吃，游玩赏乐，若想体会一番成都人的休闲生活，不妨来这里走一走。",
                img1: "https://www.csvw.com/u/cms/www/202008/1713505355OK.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/17135120IOT7.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/1713513526w7.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/17135149x3x3.jpg",
            },
            {
                title: "龙泉山",
                text:
                    "偷得浮生半日闲，继续驱车前行，在日落之前，车队来到了龙泉山，回望夕阳，即使陌不相识，也能相视一笑，上汽大众PHEV千里之行，驰骋的不仅仅是车，还有心，走过的也不仅仅是路，还有这一城一味的中华风情。华灯初上，夜色依然无法阻挡成都的闲适魅力，灯光映衬下古典优雅的安顺桥美轮美奂，旖旎夜景令人沉醉，走进人群喧闹之中，川剧变脸的种种惊奇扑面而来，让人欲罢不能。",
                img1: "https://www.csvw.com/u/cms/www/202009/011734435P53.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/16190858327D.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/01173325597y.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/16185548gDmu.jpg",
            },
        ],
        videoImg: phev7_307,
        videoUrl: phev_video_007,
    },
};

let data8 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/26131648JJoO.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/261317075cnD.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202009/021719418H2w.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202009/01110707i8R7.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202009/01110727Az0w.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202009/01110741oZN1.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/26131916hTrT.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/2613193448fE.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/261319501rp2.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/26132005Ri06.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/26132022bV42.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/26132037X725.jpg",
    },
    sec1: {
        url: phev8_101,
    },
    sec2: {
        bacUrl: phev8_201,
        text:
            "翻山越岭，穿梭于山水之间，只为与你一窥大地的秀美，上汽大众PHEV千里之行车队再次出发，领略了天府之国的繁华与闲适，再看别具民族风情的川西美景，风吹草低见牛羊，巴蜀的风情韵味，一次“尝”个遍。",
        img2: "https://www.csvw.com/u/cms/www/202009/01110150WCD7.jpg",
        img3: "https://www.csvw.com/u/cms/www/202009/011102136I48.jpg",
        img4: "https://www.csvw.com/u/cms/www/202009/0111022785re.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202009/01110409HDkR.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202009/01110427y70M.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202009/01110443f7uL.jpg",
    },
    sec3: {
        bacUrl: phev8_301,
        list: [
            {
                title: "折多山",
                text:
                    "沿着蜿蜒曲折的山路，车队抵达了“康巴第一关”——折多山，海拔四千多米，云雾缭绕，折多山娅口长长的许愿石墙上，刻着美好的祈祷和愿心。",
                img1: "https://www.csvw.com/u/cms/www/202009/011653431ga0.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/0116530071WL.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/011106077w4D.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/200015111L8D.jpg",
            },
            {
                title: "木雅圣地景区",
                text:
                    "翻越折多山，眼前的景色瞬间朗阔起来，翻腾的云海透映着霞光，山峦叠翠，群山如绿海般接二连三地涌来，牦牛成群结队，悠闲慢行，蓝天之下，草甸之上，金光乍现，浓郁的康定风情美得令人不舍眨眼。",
                img1: "https://www.csvw.com/u/cms/www/202009/01165319YwFN.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/1619121862Qp.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/011105453y32.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/16185855Qc87.jpg",
            },
            {
                title: "康巴风情",
                text:
                    "从成都往新都桥驶去，“摄影家走廊”的称号果然名不虚传，沿途草原广袤，如同世外桃源，让人身心都变得开阔起来。",
                img1: "https://www.csvw.com/u/cms/www/202009/02171705oqFa.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/0217174035i4.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/011105032l5Z.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/011105291428.jpg",
            },
            {
                title: "贡嘎山星空",
                text:
                    "夜晚的藏区显得格外的静谧，没有了城市里繁华的灯火，夜空中星星都争相冒了出来，躺在草地上抬头仰望，星河璀璨，随手一拍，便是电影画面式的场景，感觉十分治愈，“蜀山之王”贡嘎山立在浩瀚的星空之下，更显神秘与壮美。这里的白日属于蓝天草地，而夜晚则属于篝火晚会，手拉着手围着火堆跳上一舞，就着民族气息浓厚的歌声，人与人之间的热情蔓延到心里。",
                img1: "https://www.csvw.com/u/cms/www/202008/17134947B4yN.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/1713500397O2.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/17135018qYl4.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/1713503249cn.jpg",
            },
        ],
        videoImg: phev8_307,
        videoUrl: phev_video_008,
    },
};

let data9 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/261322047rO4.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/26132225rc8h.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202009/0318243269u3.png",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/261323033K3N.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/26132320So76.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/2613233323k4.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202009/03182520R1Ib.png",
        sec5Title: "https://www.csvw.com/u/cms/www/202009/03182018596N.png",
        sec6Title: "https://www.csvw.com/u/cms/www/202009/03182241g9U4.png",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202009/03182618a0CY.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202009/03182806T4Z5.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/261325136Y55.jpg",
    },
    sec1: {
        url: phev9_101,
    },
    sec2: {
        bacUrl: phev9_201,
        text:
            "告别了如诗如画的新都桥，上汽大众PHEV千里之行再次出发，继续探寻川西美景，惊叹于大自然的鬼斧神工，流连于市井小巷的人间烟火。",
        img2: "https://www.csvw.com/u/cms/www/202008/16191258bmoV.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/16191315o6F9.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/16191329S4pY.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/1817031722Bl.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/181703494oV2.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/181704047uY1.jpg",
    },
    sec3: {
        bacUrl: phev9_301,
        list: [
            {
                title: "墨石公园景区",
                text:
                    "坐落在八美镇卡玛村与中古村交界处的墨石公园，被称为道孚八美之一，黑灰色的石林绵延在鲜水河的断裂带上，像一幅浑然天成的水墨画，层峦叠嶂，景象万千。一行人顺着景区栈道行走，仿佛误入了神秘的“异域星球”，怪石嶙峋，别有一番体验，褪去繁杂的装饰与点缀，在恢弘的荒野中，感受阳光、岩石、草木带来自然的生机。",
                img1: "https://www.csvw.com/u/cms/www/202009/021453211m3y.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/021452432X37.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/02145406OQMs.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/011110382K54.jpg",
            },
            {
                title: "自贡市盐业历史博物",
                text:
                    "领略了恢弘又神秘的地质奇观，车队一路前往自贡，有着“千年盐都”美誉的自贡，盐业历史博物馆自然是必经的“打卡”地。馆内陈列丰富，记录了2000多年的盐业历史画卷，博物馆设计精巧,结构繁复，融和了宫廷与民间的建筑风格，不仅是记录历史的教育基地，同时也是不可多得的建筑瑰宝。",
                img1: "https://www.csvw.com/u/cms/www/202008/16191446nB64.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/201014171b11.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/16190251a38V.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/20001535L1B9.jpg",
            },
            {
                title: "乐山大佛",
                text:
                    "“佛是一座山，山是一尊佛”，来到乐山大佛的脚下，车队的每个人无一不赞叹大佛的雄伟壮观、高耸入云的乐山大佛。造型庄严，神情栩栩如生，历经千年风霜，仍安坐于滔滔岷江之畔。“人间烟火气，最抚凡人心”，夜幕降临，华灯初上，街边也开始热闹起来，甜皮鸭、钵钵鸡、海鲜、烧烤，各式各样的川菜、小吃瞬间唤醒味蕾，熙熙攘攘的人群，吵吵闹闹的街市，满足口腹之欲的同时，也享受着忙碌一天过后的闲暇。",
                img1: "https://www.csvw.com/u/cms/www/202009/01165103g573.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/16191402JBJ2.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/021721408vQv.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/021723584OQ2.jpg",
            },
        ],
        videoImg: phev9_307,
        videoUrl: phev_video_009,
    },
};


let data10 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/26132616eoU6.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/261326368G0d.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/26132658994U.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/261327157CMJ.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/26132732ogY1.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/26132748p1pV.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/2613280745B0.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/26132826hFEJ.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/261328486HKc.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/261329083QHZ.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/26132923h6HQ.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/26132940N6Z2.jpg",
    },
    sec1: {
        url: phev10_101,
    },
    sec2: {
        bacUrl: phev10_201,
        text:
            "都说蜀道难，难于上青天！一路向重庆而去，上汽大众PHEV车队的所有人都见证了这一点，只武隆这一段，山川叠皱，峰岚起伏的险峻山路，鬼斧神工，天然雕琢的地质奇迹，就让人不由地小心翼翼起来。",
        img2: "https://www.csvw.com/u/cms/www/202008/161915105192.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/16191526F8P9.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/16191543d8il.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/1619032103pt.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/16190341B470.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/1619040078vF.jpg",
    },
    sec3: {
        bacUrl: phev10_301,
        list: [
            {
                title: "仙女山",
                text:
                    "“无限风光在险峰”，这句话用在这里似乎特别的贴切。在仙女山游客中心驻足休整不过一瞬，静逸圣洁的高山草原，远处郁郁葱葱的山峦叠嶂，更给了车队征服前行道路的动力。武隆的美从上空俯览，就能窥出端倪，静幽又神秘的奇特景观，藏下了多少世间珍奇。天生三桥，天然就是个奇迹。桥体与石壁浑然天成，高耸恢宏，多少游客慕名前来，在这森木茂盛，青苔斑驳的人间秘境里，领略着天下之大，无奇不有的洗礼。雄奇、险秀是这里的代名词，车队一行人在曲折山路中前行，悬崖夹壁中错身，转眼却又被那青苔覆盖的驿馆所吸引。",
                img1: "https://www.csvw.com/u/cms/www/202009/01165444R7hE.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/01165459D1tP.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/01112120Pk2s.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/01112136O4rK.jpg",
            },
            {
                title: "天福官驿",
                text:
                    "天福官驿，是多部影片的拍摄地，其坐落在幽深的地缝谷底，周围岩石峥嵘，绝壁入云，半含半露，而作为古涪州至黔州的要驿，它经历了什么，只有历史知道。再往前，变形金刚兀然而立，吸引了不少游客的目光，分分钟将人带入好莱坞大片的氛围。这里拥有瀑布流泉、绝壁洞穴、幽深峡壁等，多种地质奇观，由下而上，仰望一线天际，不禁震撼于大自然的奇险壮美，天然氧吧的地貌，文甲的容气差昔木的清悉。",
                img1: "https://www.csvw.com/u/cms/www/202008/16191604g560.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/01165408u329.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/161904237U0p.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/011121042Oi8.jpg",
            },
        ],
        videoImg: phev10_307,
        videoUrl: phev_video_010,
    },
};

let data11 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/26133012m2d9.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/261330307136.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/261331360wP2.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/261331558503.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/26133211EJt5.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/261332387EK8.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/2613325642u4.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/26133315B9IR.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/261333320d18.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/26133352wd3i.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/261334077677.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/26133435MBy8.jpg",
    },
    sec1: {
        url: phev11_101,
    },
    sec2: {
        bacUrl: phev11_201,
        text:
            "从武隆的崇山峻岭中出发，去往麻辣之都，上汽大众PHEV千里之行，来到魔幻的8D山城、辣味雾都——重庆，带你一起探索山城的魅力。",
        img2: "https://www.csvw.com/u/cms/www/202008/241108301Z1L.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/241108533M09.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/2411093827u3.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/2411100301W9.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/241110195D99.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/24111036c6x1.jpg",
    },
    sec3: {
        bacUrl: phev11_301,
        list: [
            {
                title: "不夜重庆",
                text:
                    "将重庆周边游了一个遍，车队往城市中心进发，深入体味最正宗的雾都风味。所谓“无夜景不重庆”，夜晚的重庆美得更具特色。朝天门码头、江北嘴大剧院等，在霓虹交错之中流光溢彩，洪崖洞犹如《千与千寻》的不思议之街，让人仿佛身处二次元世界。",
                img1: "https://www.csvw.com/u/cms/www/202009/02132812E4H5.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/24111157f5G2.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/0213274488D1.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/24111349597s.jpg",
            },
            {
                title: "魅力重庆",
                text:
                    "探访一座城，体味一种生活，自带网红体质的重庆，就像一个磨人的“小妖精”，时刻诱惑着你想去旅行的心。重庆是一座神奇的城，也有一样神奇的交通，轻轨穿楼而过的李子坝站，已经成为了火爆的网红打卡地。特殊的地形，造就了雾都特殊的道路，车队也体验了一把网传让导航都失灵的“最复杂”立交，在奔驰中享受“征服”这座城的快感。如果你想尝试当地特色的交通工具，不妨试试乘坐下长江索道，它被誉为“万里长江第一条空中走廊”，和“山城空中公共汽车”，迄今已经运行三十余年，成为了重庆人生活的一部分。",
                img1: "https://www.csvw.com/u/cms/www/202008/2411121713kk.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/2411123374So.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/24111404Zt9c.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/2411141928uU.jpg",
            },
            {
                title: "热辣重庆",
                text:
                    "重庆的麻辣美食，足以让每一个人都热血沸腾，在小面的香气中苏醒，这才是旅途中完美的早晨，而越热越吃的火锅是当地的“怪象”，面对这样一餐热辣盛宴，挥汗淋漓之间，身心都舒畅了。",
                img1: "https://www.csvw.com/u/cms/www/202008/241113046eoF.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/24111318suqh.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/24111433Zl3r.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/2411144867X2.jpg",
            },
        ],
        videoImg: phev11_307,
        videoUrl: phev_video_011,
    },
};


let data12 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/311606008AG2.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/31160619cA3l.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/31160647oJ5F.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/31160705C3QK.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/31160720Q8us.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/311607355z34.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/31160841fn5a.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/311609053h67.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/311609215ni4.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/3116095998n8.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/31161021f3Z5.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/311610365dhu.jpg",
    },
    sec1: {
        url: "https://www.csvw.com/u/cms/www/202008/31102238Pw9M.jpg",
    },
    sec2: {
        bacUrl: "https://www.csvw.com/u/cms/www/202008/31154052auv5.jpg",
        text:
            "告别川渝，上汽大众PHEV千里之行，行至湘北。赏洞庭天下水，观岳阳天下楼，漫步橘子洲头，山水之外，翰墨流香，走近文人墨客向往的诗和远方。",
        img2: "https://www.csvw.com/u/cms/www/202008/311038384I63.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/311051318ByX.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/311051541Kk4.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/311645564jid.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/311646220f73.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/31164638e00M.jpg",
    },
    sec3: {
        bacUrl: "https://www.csvw.com/u/cms/www/202008/3115434991SD.jpg",
        list: [
            {
                title: "岳阳楼",
                text:
                    "靠巴丘，临洞庭，望君山，接长江，车队来到了江南三大名楼之一的岳阳楼。“先天下之忧而忧，后天下之乐而乐”，北宋范仲淹的《岳阳楼记》更使其名传四方。遥望洞庭湖水，碧波无垠，体味古人纵情山水的落落襟怀。继续前行，便来到了为纪念范仲淹与滕子京两位先贤，所修建的双公祠，双公祠白墙青瓦，古朴典雅。面向烟波浩淼的洞庭湖，范公滕公的青铜制像端坐祠内，一座楼、两个人，成就传世经典。",
                img1: "https://www.csvw.com/u/cms/www/202008/311052338zBV.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/311052484799.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/31105624p18m.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31105643639v.jpg",
            },
            {
                title: "洞庭湖",
                text:
                    "走近八百里洞庭，满目都是烟波缭绕、水光潋滟的盛景，虽因时移世异，源于上古云梦泽的湖面已逐步萎缩，却依然山水相济，气象万千，这一派鸟鸣鱼跃的山水之美，足可醉人。别过洞庭，于灌水潺潺中，上汽大众PHEV千里之行车队驶入了湘江之畔。",
                img1: "https://www.csvw.com/u/cms/www/202009/021330244QX2.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/021330576S0F.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/021329509sy5.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/02133041d317.jpg",
            },
            {
                title: "橘子洲",
                text:
                    "橘子洲横卧江心，林木葱郁，这里远可观岳麓山、长沙城，近可赏宫阁雕塑、河沙成滩，见证着峥嵘岁月和时间变迁。",
                img1: "https://www.csvw.com/u/cms/www/202008/3110533712TA.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31105352oQw5.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/311057320w37.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31105749Y2XV.jpg",
            },
            {
                title: "岳麓书院",
                text:
                    "赫赫有名的“千年学府” 岳麓书院，坐落在湘江之畔，岳麓山下，从这里走出的名人大家不知凡几，朱熹、王夫之、曾国藩等人都曾在此求学，这里每一片树叶都带着浓浓的书香，每一个石阶都刻印着历史的回声。上汽大众PHEV车队徜徉在书院之中，带你感受这传承千年的书卷气息。",
                img1: "https://www.csvw.com/u/cms/www/202008/31105414iq71.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31105430r9Cl.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/31105807LV97.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/311058240767.jpg",
            },
        ],
        videoImg: "https://www.csvw.com/u/cms/www/202009/0118071548jR.jpg",
        videoUrl: "https://www.csvw.com/u/cms/www/202009/021314482Y9X.mp4",
    },
};

let data14 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/311611011h7o.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/311611178822.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/311611336YKt.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/31161152jqX6.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/3116120723pf.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/31161223793q.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/31161243V0iV.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/3116130150GP.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/311615085yUp.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/31161522K619.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/31161537X90h.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/3116155548nX.jpg",
    },
    sec1: {
        url: "https://www.csvw.com/u/cms/www/202008/3110255282QY.jpg",
    },
    sec2: {
        bacUrl: "https://www.csvw.com/u/cms/www/202008/31154117g86k.jpg",
        text:
            "从楚汉名城长沙一路驰骋，上汽大众PHEV千里之行车队，来到了九省通衢的大城武汉，感受荆楚风韵，探寻市井街巷中的人间烟火气。",
        img2: "https://www.csvw.com/u/cms/www/202008/31110010d9g4.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/31110026olQM.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/31110043I404.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/31110505y93V.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/31110528N904.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/31110543a057.jpg",
    },
    sec3: {
        bacUrl: "https://www.csvw.com/u/cms/www/202008/311544153tS3.jpg",
        list: [
            {
                title: "武汉长江大桥",
                text:
                    "横卧于汉阳龟山和武昌蛇山之间的武汉长江大桥，被称为“万里长江第一桥”。60余年岁月沧桑，巍然屹立，风采依旧。“一桥飞架南北，天堑变通途”，驾车驰行，江风迎面而来，长江两岸宛如巨幅油画，鳞次栉比的高楼大厦沐浴在霞光中，光影交错，层次丰富。",
                img1: "https://www.csvw.com/u/cms/www/202008/311101108696.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31110126aF3i.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/311106108m58.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31110627U45w.jpg",
            },
            {
                title: "黄鹤楼",
                text:
                    "驰行长江边，黄鹤楼便赫然眼前，宝塔和牌坊林立，轩廊和亭阁相映，千年古楼巍峨耸立于武昌的蛇山，众多文人墨客在此宴游题诗，停车驻足，目之所及皆是历史的沉淀登楼远眺浩渺的江水，饱览壮观的长江大桥，见证武汉日日更新的岁月流转。",
                img1: "https://www.csvw.com/u/cms/www/202008/31110234yp53.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31110252EE05.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/311106450j60.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/311107212TnT.jpg",
            },
            {
                title: "鹦鹉洲",
                text:
                    "江心沙洲遥遥在水一方的秀丽，是可望不可及的朦胧之美，鹦鹉洲洲势逶迤，沿岸民风古朴，滔滔江水奔腾而去，载着独有的码头江湖文化，造就了这灵气毓秀之地。",
                img1: "https://www.csvw.com/u/cms/www/202009/0310241295ZZ.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31110324d74F.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/03102512yY8M.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31110756tN4S.jpg",
            },
            {
                title: "武汉大学",
                text:
                    "环绕东湖水，坐拥珞珈山，炎炎夏日里的武汉大学依然美景如画，青瓦白墙，绿荫婆娑，江城多山，珞珈独秀，央央学府，文气滔滔，百年武大，砥砺风华。",
                img1: "https://www.csvw.com/u/cms/www/202008/311103427M20.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/02133559kqAl.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/31110817Si1o.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/0213351931l8.jpg",
            },
            {
                title: "东湖",
                text:
                    "沿着曲折的湖岸前行，一条百余公里的绿道便出现在眼前，各种草木与水景相映成趣，煞是壮观，行至林荫道，城市的繁华喧嚣被抛却脑后，看老人垂钓、中年慢跑、恋人谈情，览落日余晖，闻雁啼鹭鸣，尽享逍遥自在游。",
                img1: "https://www.csvw.com/u/cms/www/202009/021328576D23.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/3111043767s4.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/021328310y38.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31110921JTS9.jpg",
            },
        ],
        videoImg: "https://www.csvw.com/u/cms/www/202009/01181028330w.jpg",
        videoUrl: "https://www.csvw.com/u/cms/www/202009/0213153985EI.mp4",
    },
};

let data13 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/31161645H83f.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/311617012682.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/31161717HW5L.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/311617379Ax1.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/311617528220.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/31161806xwjy.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/3116182601Ty.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/31161842Zo73.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/311618570m6t.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/3116191368gs.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/31161927O249.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/31161941ILv9.jpg",
    },
    sec1: {
        url: "https://www.csvw.com/u/cms/www/202008/311110521Z9V.jpg",
    },
    sec2: {
        bacUrl: "https://www.csvw.com/u/cms/www/202008/311541375j17.jpg",
        text:
            "TA是一座“水”的城市，古人称其“襟三江而带五湖”，毗邻中国最大淡水湖鄱阳湖，奔腾不止的赣江南北纵贯。TA也是一座“火”的城市，革命的第一枪在这里打响，火红的军旗在这里升起，TA还是一座且“古” 且“今” 的城市，从战国时代便载于书册，又见证了新中国崛起和发展历程。",
        img2: "https://www.csvw.com/u/cms/www/202008/31111157h59h.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/311112169F13.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/31111232j43l.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/311116111TM7.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/31111631v430.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/31111645389O.jpg",
    },
    sec3: {
        bacUrl: "https://www.csvw.com/u/cms/www/202008/3115444565XL.jpg",
        list: [
            {
                title: "南昌八一起义纪念馆",
                text:
                    "红色的记忆铭刻在城市里，南昌起义总指挥部旧址原为“江西大旅社”，1927年，起义部队包下这里成立总指挥部，1957年这里被定为“南昌八一起义纪念馆”，馆名由陈毅元帅手书。具有伟大历史意义的无数瞬间，仿佛凝固在了这座灰色的大楼里，生动的雕塑内似乎还流淌着革命的热血。",
                img1: "https://www.csvw.com/u/cms/www/202008/31111302ylDD.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/021333234FxQ.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/31111717Wu6x.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/021332565oM2.jpg",
            },
            {
                title: "八一广场",
                text:
                    "八一南昌起义纪念塔，巍然屹立在广场上，红色的八一军旗“飘扬”在塔尖，风雨不改其色。巨型的“汉阳造”步枪直指苍穹，纪念着一段可歌可泣的历史。",
                img1: "https://www.csvw.com/u/cms/www/202009/02132543p400.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31111356M57e.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/02132509CXD1.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/311118082Me9.jpg",
            },
            {
                title: "滕王阁",
                text:
                    "低垂夜色下的赣江愈发沉静，始建于唐永徽年间的滕王阁静静矗立着，“落霞与孤鹜齐飞，秋水共长天一色”，初唐诗人王勃的名句与建筑一起流传了百世，碧色的琉璃瓦、朱红的楼台，夜色中的滕王阁宛如一座通透的水晶建筑，滕王阁是古代储藏经史典籍之阁，是南昌深厚历史人文积淀的象征。",
                img1: "https://www.csvw.com/u/cms/www/202008/31111415RZwx.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/311114363ZM0.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/31111827RV7b.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31111847qbN3.jpg",
            },
        ],
        videoImg: "https://www.csvw.com/u/cms/www/202009/0118094073Pg.jpg",
        videoUrl: "https://www.csvw.com/u/cms/www/202009/02131722P843.mp4",
    },
};

let data15 = {
    mobile: {
        sec1Url: "https://www.csvw.com/u/cms/www/202008/261553175o14.png",
        sec2Kv: "https://www.csvw.com/u/cms/www/202008/311620049NlC.png",
        sec2MapUrl: "https://www.csvw.com/u/cms/www/202008/31162021e8B0.png",
        sec3Title: "https://www.csvw.com/u/cms/www/202008/3116203687W5.jpg",
        sec3Img2: "https://www.csvw.com/u/cms/www/202008/31162051Bo6r.jpg",
        sec3Img3: "https://www.csvw.com/u/cms/www/202008/3116210618Z7.jpg",
        sec3Img4: "https://www.csvw.com/u/cms/www/202008/31162119528K.jpg",
        sec4Title: "https://www.csvw.com/u/cms/www/202008/31162136S1Y5.jpg",
        sec5Title: "https://www.csvw.com/u/cms/www/202008/311621536259.jpg",
        sec6Title: "https://www.csvw.com/u/cms/www/202008/311622101U89.jpg",
        sec6NavLeft: "https://www.csvw.com/u/cms/www/202008/311622247tV1.jpg",
        sec6NavRight: "https://www.csvw.com/u/cms/www/202008/31162238Z3Z7.jpg",
        sec7Bck: "https://www.csvw.com/u/cms/www/202008/311622528he4.jpg",
    },
    sec1: {
        url: "https://www.csvw.com/u/cms/www/202008/311120176w28.jpg",
    },
    sec2: {
        bacUrl: "https://www.csvw.com/u/cms/www/202008/31154919y61u.jpg",
        text:
            "告别英雄之城南昌，上汽大众PHEV千里之行车队踏上了收官之旅，途径风光旖旎的南京，奔向摩登繁华的上海，为二十多天的行程画上了圆满的句号。",
        img2: "https://www.csvw.com/u/cms/www/202008/311121260430.jpg",
        img3: "https://www.csvw.com/u/cms/www/202008/3111214389LN.jpg",
        img4: "https://www.csvw.com/u/cms/www/202008/311121592e36.jpg",
        img2Pop: "https://www.csvw.com/u/cms/www/202008/31112658hM84.jpg",
        img3Pop: "https://www.csvw.com/u/cms/www/202008/311127142y46.jpg",
        img4Pop: "https://www.csvw.com/u/cms/www/202008/311127306991.jpg",
    },
    sec3: {
        bacUrl: "https://www.csvw.com/u/cms/www/202008/3115493966bu.jpg",
        list: [
            {
                title: "中华门",
                text:
                    "车对一行从中华门驶入南京，中华门瓮城是现存规模最大的堡垒瓮城，享有“天下第一瓮城”美誉，及时历经风雨沧桑，却依然雄姿挺拔，气势恢弘。",
                img1: "https://www.csvw.com/u/cms/www/202008/31112219Yy60.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/3111223676JH.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/311128331AjF.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31112851ID35.jpg",
            },
            {
                title: "秦淮河",
                text:
                    "出了中华门，车队继续向前行驶，有着“十里秦淮”美称的秦淮河，犹如一幅画卷缓缓铺陈开来。两岸建筑有着古色古香的韵味，人群熙熙攘攘更显市井繁华。",
                img1: "https://www.csvw.com/u/cms/www/202008/311122534s9d.jpg",
                img2: "https://www.csvw.com/u/cms/www/202009/02133409o6sN.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/31112908AuFd.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202009/02133339toz9.jpg",
            },
            {
                title: "夫子庙",
                text:
                    "体会过了旖旎秦淮的诗情画意，沿着河岸步行片刻，就可以来到位于北岸贡院街的夫子庙，夫子庙曾是文人雅士汇聚之地，如今，这里成为了繁华的步行街，琳琅满目的小商品和各色金陵小吃，吸引着天南海北的游客前来“打卡”。或许你会在这里邂逅让人食指大动的，鸭血粉丝汤、盐水鸭、皮肚面、牛肉锅贴……遇到了就别错过，停下来享受一餐美味吧！",
                img1: "https://www.csvw.com/u/cms/www/202008/31112326jr9e.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31112344861N.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/3111294351iq.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31112957XE2x.jpg",
            },
            {
                title: "中山陵",
                text:
                    "离开热闹的城市“烟火气”， 探寻历史的旧迹，车队行驶到位于紫金山的中山陵，大片郁郁葱葱的树木与蓝天交相辉。白墙蓝瓦的陵墓，庄严简朴却又别具一格。",
                img1: "https://www.csvw.com/u/cms/www/202009/03141330132c.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31112419J752.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/03141352924z.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/311130347712.jpg",
            },
            {
                title: "栖霞山",
                text:
                    "“一座栖霞山，半部金陵史”，栖霞山堪称避暑胜地，成片的枫林颜色尚且葱翠，枝叶繁茂，投下浓浓绿荫，令人流连忘返。",
                img1: "https://www.csvw.com/u/cms/www/202008/311124522i3r.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/311125106K0P.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/311130573a65.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/311131140Z3z.jpg",
            },
            {
                title: "黄浦江畔",
                text:
                    "隔着奔流的黄浦江，一面是历经百年的外滩万国建筑博览群，一面是陆家嘴鳞次栉比的现代摩登大厦，见证着上海的繁华，凝望岁月的流转。",
                img1: "https://www.csvw.com/u/cms/www/202009/02133144832b.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31112543S3o1.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202009/021331164sd5.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31113147297j.jpg",
            },
            {
                title: "豫园",
                text:
                    "始建于明代的豫园，有着江南古典园林的韵味，凝练出老上海的优雅，成为了一张特色旅游名片。纵横交错的道路上车水马龙，这座城市彰显着旺盛的生命力，上汽大众PHEV车队一路驰行，终于来到了旅途的终章－安亭。跨越二十多座城市，飞驰8500多公里，上汽大众PHEV以持久续航能力与可靠产品性能，陪你看遍祖国大好河山。",
                img1: "https://www.csvw.com/u/cms/www/202008/31112558F1U9.jpg",
                img2: "https://www.csvw.com/u/cms/www/202008/31112613fb74.jpg",
                img1Pop: "https://www.csvw.com/u/cms/www/202008/31113205l78z.jpg",
                img2Pop: "https://www.csvw.com/u/cms/www/202008/31113222421a.jpg",
            },
        ],
        videoImg: "https://www.csvw.com/u/cms/www/202009/01180802a406.jpg",
        videoUrl: "https://www.csvw.com/u/cms/www/202009/02131619J8w5.mp4",
    },
};

export { data1, data2, data3, data4, data5, data6, data7, data8, data9, data10, data11, data12, data13, data14, data15 };